import AssessmentIcon from "@mui/icons-material/Assessment";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import HomeIcon from "@mui/icons-material/Home";
import KeyIcon from "@mui/icons-material/Key";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import {
  alpha,
  Avatar,
  Box,
  BoxProps,
  darken,
  Dialog,
  Divider,
  IconButton,
  Link,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  DialogTitle,
  getMonogram,
  ListNavigation,
  NavigationMenuItem,
  Spacer,
  Toolbar,
  useDownloadUrl,
} from "common";
import useAccess from "features/profile/useAccess";
import I18n from "i18n";
import { useState } from "react";
//@ts-ignore
import { BarChart } from "@mui/icons-material";
import Logo from "app/components/Logo/Logo";
import { useAppSelector } from "app/hooks";
import useNotifyCount from "features/bookings/useNotifyCount";
import { selectProfile } from "features/profile/profileSlice";
import WangoghLogo from "wangogh/WangoghLogo";
import PartnerUserMenu from "./PartnerUserMenu";

export interface GroupProps extends BoxProps {
  open?: boolean;
}

export interface PartnerSidebarMenuProps {
  open?: boolean;
  temporary?: boolean;
  setOpen?: (open?: boolean) => void;
}
export default function PartnerSidebarMenu({
  open,
  setOpen,
  temporary,
}: PartnerSidebarMenuProps) {
  const theme = useTheme();
  const profile = useAppSelector(selectProfile);
  const { hasPermissions, hasRoles, notHasRoles } = useAccess();
  const { downloadUrl } = useDownloadUrl();
  const notifyCount = useNotifyCount();
  const [termsOpen, setTermsOpen] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Paper
      className={"AppSidebarWrapper"}
      /*sx={
        temporary
          ? {
              flex: 1,
              display: "flex",
              flexDirection: "column",
              color: theme => theme.palette.common.white,
              backgroundColor: theme =>
                theme.palette.mode === "dark"
                  ? theme.palette.background.paper
                  : theme.palette.primary.main,
            }
          : {
              flex: 1,
              display: "flex",
              flexDirection: "column",
              color: theme => theme.palette.common.white,
              borderRadius: theme => theme.shape.borderRadius / 3,
              backgroundColor: theme =>
                theme.palette.mode === "dark"
                  ? theme.palette.background.paper
                  : theme.palette.primary.main,
              m: 2,
            }
      }*/
    >
      {!temporary && (
        <>
          <Box
            sx={{
              p: 2,
              overflow: "hidden",
            }}
          >
            <Toolbar sx={{ width: "fit-content" }}>
              <Logo size={40} />
              {open && (
                <>
                  <Spacer w={2} />
                  <Typography
                    variant="h6"
                    sx={{ display: open ? "block" : "none" }}
                  >
                    {I18n.t("App.title")}
                  </Typography>
                </>
              )}
            </Toolbar>
          </Box>
          <Divider />
        </>
      )}
      <ListNavigation minimized={!open} pattern="/">
        <NavigationMenuItem
          label="Foglalási felület"
          value=""
          absolute
          icon={<HomeIcon />}
        />
        <NavigationMenuItem
          label="Foglalások"
          value="bookings"
          icon={<KeyIcon />}
        />
        <NavigationMenuItem
          label={I18n.t("PartnerFeed.newsTitle")}
          value="news"
          icon={<RssFeedIcon />}
        />
        {hasPermissions("report.menu_commission") && (
          <NavigationMenuItem
            label={I18n.t("CommissionReport.title")}
            value="commission-report"
            icon={<AssessmentIcon />}
          />
        )}
        <NavigationMenuItem
          label="Statisztikák"
          value="statistics"
          icon={<BarChart />}
        />
        <NavigationMenuItem
          label="Kapcsolat"
          value="contact"
          icon={<ContactMailIcon />}
        />
      </ListNavigation>
      <Box flex={1}></Box>
      <Box sx={{ padding: 1 }}>
        <Toolbar
          sx={{
            justifyContent: open ? "flex-end" : "center",
            paddingBottom: 0,
          }}
        >
          <IconButton
            onClick={() => setOpen && setOpen(!open)}
            color="inherit"
            sx={{
              backgroundColor: theme =>
                theme.palette.mode === "light"
                  ? "rgba(255,255,255,0.1)"
                  : theme.palette.action.hover,
              "&:hover": {
                backgroundColor: theme =>
                  theme.palette.mode === "light"
                    ? "rgba(255,255,255,0.2)"
                    : theme.palette.action.selected,
              },
            }}
          >
            {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </Toolbar>
        <Link
          onClick={() => setTermsOpen(true)}
          sx={{
            mt: 1,
            mb: 1,
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            cursor: "pointer",
            fontSize: "0.75rem",
            textDecoration: "none",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          {open ? "Általános Szerződési Feltételek" : "ÁSZF"}
        </Link>
        <Toolbar
          sx={{
            marginLeft: theme.spacing(1),
          }}
        >
          <Avatar
            sx={{
              backgroundColor: theme => alpha(theme.palette.primary.dark, 0.6),
              color: "white",
            }}
            src={profile.file_id ? downloadUrl(profile.file_id) : undefined}
          >
            {getMonogram(profile)}
          </Avatar>
          {open && (
            <>
              <Spacer w={1} />
              <Box>
                <Typography variant="body2">
                  {profile.last_name} {profile.first_name}
                </Typography>
                {!!profile?.partner_name && (
                  <Typography
                    variant="body2"
                    fontSize={10}
                    sx={{
                      color: theme => theme.palette.text.secondary,
                    }}
                  >
                    {profile?.partner_name}
                  </Typography>
                )}
              </Box>
              <Spacer right />
              {<PartnerUserMenu />}
            </>
          )}
        </Toolbar>
      </Box>
      <Divider />
      <Spacer h={1} />
      <Toolbar
        sx={{
          paddingLeft: 1,
          paddingRight: 2,
          paddingTop: 0,
          paddingBottom: 0.5,
        }}
      >
        <Spacer right />
        <Link
          component="a"
          href="https://www.wangoghsoft.com"
          target="_blank"
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            color: theme => darken(theme.palette.primary.dark, 0.4),
            textDecoration: "none",
          }}
        >
          {open && (
            <>
              <Typography variant="body2" fontSize={10}>
                created by
              </Typography>
              <Spacer w={1} />
            </>
          )}
          <WangoghLogo sx={{ width: 36 }} typo={false} />
        </Link>
      </Toolbar>
      <Dialog
        open={termsOpen}
        onClose={() => setTermsOpen(false)}
        maxWidth="lg"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{
          sx: {
            height: isMobile ? "100%" : "90vh",
          },
        }}
      >
        <DialogTitle onClose={() => setTermsOpen(false)}>
          Általános Szerződési Feltételek
        </DialogTitle>
        <Box
          sx={{
            flex: 1,
            overflow: "hidden",
            position: "relative",
          }}
        >
          <iframe
            src="https://silver-line.hu/wp-content/uploads/2025/05/UZLETSZABALYZAT_hun_silver_2025.3.11.pdf"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
            title="Üzletszabályzat"
          />
        </Box>
      </Dialog>
    </Paper>
  );
}
